export const VIEW_CUSTOMERS_LIST_URL = 'view://Leads/CustomersList';
export const SET_CUSTOMERS_LIST_DATA = 'SET_CUSTOMERS_LIST_DATA';
export const GET_CUSTOMERS_LIST_DATA = 'GET_CUSTOMERS_LIST_DATA';



// WEBPACK FOOTER //
// ./src/modules/Leads/CustomersList/constants/index.js